export enum MedicationFrequency {
    Continuous = "Continuous",
    AsDirected = "As Directed"
}
